import loadable from "@loadable/component";
import { useState } from "react";
import { useParams } from "react-router";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import Spinner from "../../components/Reusable/Spinner";
import APIS from "../../constant/EndPoint";
import useGetHook from "../../customHooks/useGetHook";
import usePatchHook from "../../customHooks/usePatchHook";
import usePostHook from "../../customHooks/usePostHook";
import CreateIcon from "../../Icons/CreateIcon";
import { queryClient } from "../../router/CourierDispathManifestRouter";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
//@ts-ignore
import { usePDFPrintHook } from "@careinfo/layout";

const EditManifestComponent = loadable(
  () => import("../../components/CourierDispatchManifest/SwitchTab")
);

const EditManifest = () => {
  const { id } = useParams();
  const [searchParams, setSearchParms] = useSearchParams();
  const [defaultValue, setDefaultValue] = useState(null);

  const { data, refetch, isLoading } = useGetHook({
    queryKey: [`mainfest-${id}`, "manifest"],
    url: `${APIS.MANIFEST}${id}/`,
    params: {},
  });
  const { data: gridData, isLoading: isgridDataLoading } = useGetHook({
    queryKey: [`manifest-status`],
    url: `${APIS.MANIFEST_STATUS}`,
    params: {},
  });

  const { mutateAsync, isLoading: isPatchLoading } = usePatchHook({
    queryKey: [`manifest-${id}`, "manifest"],
    navigateURL: "",
  });

  const handleStatusChange = (data: any) => {
    setDefaultValue(data);
  };

  const handleEdit = async (values: any, setError: any) => {
    const url = `${APIS.MANIFEST}${id}/`;
    let formData = {
      ...values,
      allowed_cities:
        values?.allowed_cities && values?.allowed_cities?.length > 0
          ? values?.allowed_cities?.map((item: any) => item?.value)
          : [],
    };

    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.error(err);
    }
  };

  const { mutateAsync: attachConsignmentMutateAsync, isPostLoading } =
    usePostHook({
      queryKey: ["manifest-items"],
    });

  const { mutateAsync: removeitems, isPostLoading: isRemoved } = usePostHook({
    queryKey: ["runsheet-items"],
    navigateURL: "",
  });

  const handleAttachConsignment = async (
    consignmentId: string,
    statusId: any,
    transit_branch: any,
    setError: any
  ) => {
    const url = `${APIS.MANIFEST_ITEMS}`;
    let formData = {
      status_id: statusId,
      manifest: id,
      transit_branch: transit_branch,
      tracking_number: consignmentId,
    };
    try {
      await attachConsignmentMutateAsync({ url, formData, setError });
    } catch (err) {
      console.error(err);
    }
  };
  const handleManualAttachConsignment = async (
    statusId: any,
    setError: any
  ) => {
    const selectedOrder = searchParams.get("selectedItems")?.split(",");
    if (!selectedOrder?.length) {
      toast.error("Please select at least one order first");
      return;
    }
    const url = `${APIS.MANIFEST_ITEMS}bulk-attach/`;
    let formData = {
      status_id: statusId,
      manifest: id,
      orders: selectedOrder,
    };
    try {
      await attachConsignmentMutateAsync({ url, formData, setError });
    } catch (err) {
      console.error(err);
    }
  };

  const handleRemove = async () => {
    const selectedOrder = searchParams.get("selectedItems")?.split(",");
    if (!selectedOrder?.length) {
      toast.error("Please select at least one order first");
      return;
    }
    const url = `${APIS.MANIFEST_ITEMS}remove-items/`;
    let formData = {
      items: selectedOrder,
    };
    try {
      const res = await removeitems({ url, formData });
      if (res?.status === 200) {
        queryClient.refetchQueries();
      }
    } catch (err) {
      console.error(err);
    }
  };

  const { downloadPrint, isPrintLoading } = usePDFPrintHook();

  const handlePrint = async (transit_branch: any) => {
    const url = `${APIS.MANIFEST}${id}/print-pdf-manifest/`;
    let formData = {
      // transit_branch: transit_branch,
    };
    try {
      const res = await downloadPrint(url, formData);
    } catch (err) {
      console.error(err);
    }
  };
  const handleSplitPrint = async () => {
    const url = `${APIS.MANIFEST}${id}/print-pdf-manifest-split/`;
    let formData = {};
    try {
      const res = await downloadPrint(url, formData);
    } catch (err) {
      console.error(err);
    }
  };
  const handleSplit = async (setError: any) => {
    const url = `${APIS.MANIFEST}${id}/split/`;
    let formData = {};
    try {
      const res = await attachConsignmentMutateAsync({
        url,
        formData,
        setError,
      });
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Edit Manifest
        </span>
      </div>
      {isLoading ? (
        <Spinner />
      ) : (
        <EditManifestComponent
          isLoading={isPatchLoading}
          data={data}
          handleEdit={handleEdit}
          gridData={gridData}
          handleAttachConsignment={handleAttachConsignment}
          handlePrint={handlePrint}
          isPrintLoading={isPrintLoading}
          id={id}
          refetch={refetch}
          handleRemove={handleRemove}
          isRemoved={isRemoved}
          handleStatusChange={handleStatusChange}
          defaultValue={defaultValue}
          isAttachLoading={isPostLoading}
          handleSplitPrint={handleSplitPrint}
          handleManualAttachConsignment={handleManualAttachConsignment}
          setDefaultValue={setDefaultValue}
          handleSplit={handleSplit}
        />
      )}
    </>
  );
};
export default EditManifest;
